<template>
  <section class="about" name="about">
    <div class="container">
      <a-typography-title :level="1"
                          data-aos="fade-down">
        About Us
      </a-typography-title>
      <a-typography-title :level="2"
                          data-aos="fade-right">
        Introduction
      </a-typography-title>
      <div class="box_list">
        <div v-for="(item,index) in expand.list"
             class="item" :class="`i_${index+1}`"
             data-aos="fade-up">
          <a-row>
            <a-col :xs="24" :md="14"
                   :order="index%2&&$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)===0?1:2">
              <a-typography-paragraph>
                <b>{{ item.t1 }}</b>
                {{ item.t2 }}
              </a-typography-paragraph>
            </a-col>
            <a-col :xs="24" :md="10"
                   :order="index%2===0&&$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?2:1">
              <div v-if="index===2" class="image"
                   @click="$Store.Overseas().openModal('modalImage',href.ImageCertificate)">
                <a />
              </div>
              <div v-else class="image" />
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import ImageCertificate from '@resource/image/overseas/home/about_certificate.jpg';

export default {
  name: 'home_about',
  data(): DataInterface {
    return {
      href: {
        ImageCertificate
      },
      expand: {
        list: [
          {
            t1: 'Galaxy-Future',
            t2: 'was founded in June 2021. With leading Serverless technology, ' +
                'it has rapidly emerged as a navigator for AI application platform services. ' +
                'In 2023, the company was awarded the titles of "Beijing Specialized, Refined, ' +
                'Unique, and New Small and Medium-sized Enterprise" and "National High-tech Enterprise". ' +
                'With the concept of "making computing as easy to use as electricity", ' +
                'the company relies on multiple patented technologies such as non-intrusive log collection, ' +
                'automatic specification torture testing, and automatic traffic torture testing to help enterprises achieve automated management of AI applications, ' +
                'AI large models, GPUs, CPUs and other computing resources, and is committed to making AI a new quality productivity engine for enterprises.'
          },
          {
            t1: 'Our',
            t2: 'team consists of experienced engineers from backgrounds such as Alibaba, Huawei, and ByteDance. ' +
                "Liu Daoru, the CEO of Galaxy-Future, used to lead Weibo's Infrastructure Department, in charge of the core business for over 10 years."
          },
          {
            t1: 'As',
            t2: 'a tech-oriented company，Galaxy-Future has strong technical research and development capabilities. ' +
                'Its core technologies, such as the self-developed data logistics engine DTExpress, the indicator governance engine CudgX, ' +
                'the shared computing power pool, rapid specification stress testing, and rapid traffic stress testing, have been awarded patent certification.'
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}public/';
@image: '@{src_image}overseas/home/';

.about {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_7;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    z-index: 0;
    .bg('@{image}about_decorate.png', 633px, 617px, true);
  }
  
  &::before {
    top: -300px;
    right: -150px;
  }
  
  &::after {
    left: -150px;
    bottom: -300px;
  }
  
  .container {
    position: relative;
    z-index: 1;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

h2.ant-typography {
  margin: @margin 0 0;
  .font(left, @title_sub, @color_12, @title_sub, true);
  
  &::before {
    @wh: 40px;
    @scale: 0.7;
    content: '';
    display: inline-block;
    width: @wh*@scale;
    height: @wh*@scale;
    margin: 0 5px 0 0;
    .bg('@{image}about_icon.png', @wh*@scale*2, @wh*@scale);
    background-position-x: 0;
    vertical-align: top;
  }
}

.box_list {
  margin: @margin_mo 0 0;
  
  .item {
    overflow: hidden;
    position: relative;
    margin: @margin_mo 0 0;
    background-color: @color_white;
    border-radius: 8px;
    .shadow(0 0 25px fade(#6E778B, 20));
    
    .loop(@i) when (@i<=3) {
      &.i_@{i} {
        .image {
          .bg('@{image}about_image_@{i}.jpg');
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    &.i_3 {
      .image {
        .transition(opacity @time);
        cursor: pointer;
        
        &:hover {
          opacity: 0.9;
        }
        
        &::before {
          @scale: 0.25;
          content: '';
          display: block;
          .center();
          .bg('@{image}about_certificate.png', 784px*@scale, 654px*@scale, true);
        }
        
        a {
          display: block;
          .position(absolute, 10px, 10px, auto, auto);
          .bg('@{imagePublic}icon_enlarge.png', 32px, 32px, true);
        }
      }
    }
    
    &:first-child {
      margin: 0;
    }
    
    div.ant-typography {
      padding: 30px;
      margin: 0;
      .font(left, @text+@line, @color_12, @text);
      
      b {
        margin: 0 4px 0 0;
        font-size: @text+4px;
      }
    }
    
    .image {
      position: relative;
      width: 100%;
      height: 100%;
      background-size: cover !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .about {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  h2.ant-typography {
    .font(left, @title_sub_mo, @color_12, @title_sub_mo, true);
    
    &::before {
      @wh: 40px;
      @scale: 0.5;
      width: @wh*@scale;
      height: @wh*@scale;
      .bg('@{image}about_icon.png', @wh*@scale*2, @wh*@scale);
      background-position-x: 0;
    }
  }
  
  .box_list {
    .item {
      .image {
        height: 160px;
      }
    }
  }
}
</style>